import { AlertTriangle, RefreshCw } from 'lucide-react'
import s from './feedback.module.css'

/**
 * Inline query-failure affordance (DES-01): the list-kit error banner plus a
 * Retry button. Render it INSTEAD of empty/"all clear"/first-use copy — a
 * failed fetch must never look like a calm zero. `compact` is the single-line
 * variant for card interiors and strips.
 */
export function ErrorState({
  message = "Couldn't load — please retry.",
  onRetry,
  compact,
}: {
  message?: string
  onRetry: () => void
  compact?: boolean
}) {
  return (
    <div
      className={compact ? `${s.errorState} ${s.errorStateCompact}` : s.errorState}
      role="alert"
    >
      <AlertTriangle size={compact ? 14 : 16} className={s.errorIcon} aria-hidden="true" />
      <span className={s.errorMessage}>{message}</span>
      <button type="button" className={s.retryBtn} onClick={onRetry}>
        <RefreshCw size={13} aria-hidden="true" />
        Retry
      </button>
    </div>
  )
}
